const isIE = () => {
  // IE 10 and IE 11
  return /Trident\/|MSIE/.test(window.navigator.userAgent)
}

if (isIE()) {
  // Create new script element
  const script = document.createElement('script')
  script.src = document.head.querySelector('[property~=outdated-script-path][content]').content

  // Append to the `head` element
  document.head.appendChild(script)
}
